import React, { useState, useEffect } from 'react';
import { useStripe, useElements, CardElement, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import productImg from "../assets/product/solidchaim.png";
import CartServices from '../services/API/CartService';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom'; 
import ProductServices from '../services/API/ProductServices';
import { BASE_URL } from '../services/Constant';
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { useLoadScript } from "@react-google-maps/api";

const libraries = ["places"]; // Load only the 'places' library

// Load your Stripe publishable key
const stripePromise = loadStripe('pk_test_51HiCo6EHLDkHxi1YwwTc185yQTBuRIZktAiqLEus7vFq1kKxsrir4UlAUVCP6rRokopLAFCYY1DKowhrjZuLhyv200gfW8PqZc');



const CheckoutForm = ({ cartProductsTotal, userId }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("productid");
  const quantity = queryParams.get("quantity");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [country, setCountry] = useState("");
  const [phoneNo, setPhoneNo] = useState("");

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyDg6Ci3L6yS5YvtKAkWQjnodGUtlNYHw9Y', // Secure API Key
    libraries,
  });

  // Function to handle address selection
  const handleAddressSelect = async (place) => {
    setAddress(place.label);
  
    const placeId = place.value.place_id;
    const geocoder = new window.google.maps.Geocoder();
  
    geocoder.geocode({ placeId }, (results, status) => {
      if (status === "OK" && results[0]) {
        const addressComponents = results[0].address_components;
  
        let cityName = "";
        let postalCodeValue = "";
        let countryCode = ""; // Use ISO 3166-1 alpha-2 code
  
        addressComponents.forEach((component) => {
          if (component.types.includes("locality")) {
            cityName = component.long_name;
          }
          if (component.types.includes("postal_code")) {
            postalCodeValue = component.long_name;
          }
          if (component.types.includes("country")) {
            countryCode = component.short_name; // This ensures you get "US" instead of "United States"
          }
        });
  
        setCity(cityName);
        setPostalCode(postalCodeValue);
        setCountry(countryCode); // Use the country code here
      }
    });
  };
  

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) return;

    const cardElement = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        email,
        name: `${firstName} ${lastName}`,
        address: {
          line1: address,
          city,
          postal_code: postalCode,
          country,
        },
        phone: phoneNo,
      },
    });

    if (error) {
      console.error(error);
    } else {
      const response = await axios.post(
        "https://jewellery.testingwebsitelink.com/api/cart/buy-now",
        {
          user_id: userId,
          first_name: firstName,
          last_name: lastName,
          address,
          city,
          postal_code: postalCode.replace(/\D/g, "") || "00000",
          country,
          phone_no: phoneNo,
          email,
          pm_card_Id: paymentMethod.id,
          product_id: productId,
          quantity: quantity
        }
      );

      if (response.data.status) {
        navigate("/");
        console.log("Payment successful and order placed:", response.data);
      } else {
        console.error("Payment or order placement failed:", response.data);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-lg p-6 space-y-4">
      {/* CONTACT */}
      {/* NAME FIELDS */}
      <h6 className="text-lg font-semibold text-gray-700">CONTACT</h6>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input
          type="text"
          placeholder="FIRST NAME"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          className="p-3 border border-gray-300 rounded-lg"
        />
        <input
          type="text"
          placeholder="LAST NAME"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          className="p-3 border border-gray-300 rounded-lg"
        />
      </div>
      
      <div>
        <input
          type="email"
          placeholder="EMAIL"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
      <input
        type="text"
        placeholder="PHONE"
        value={phoneNo}
        onChange={(e) => setPhoneNo(e.target.value)}
        className="w-full p-3 border border-gray-300 rounded-lg"
      />
      </div>

     

      

<div>      
        <h6 className="text-lg font-semibold text-gray-700">ADDRESS</h6>
        {isLoaded ? (
          <GooglePlacesAutocomplete
            selectProps={{
              onChange: handleAddressSelect,
              placeholder: "Enter Address",
            }}
            className="text-white bg-[#45610e79] p-2 w-full rounded-md border border-[#CACACA]"
          />
        ) : (
          <p>Loading...</p>
        )}
      </div>

      {/* AUTO-FILLED LOCATION FIELDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <input
          type="text"
          placeholder="CITY"
          value={city}
          readOnly
          className="p-3 border border-gray-300 rounded-lg bg-gray-100"
        />
        <input
          type="text"
          placeholder="POSTAL CODE"
          value={postalCode}
          readOnly
          className="p-3 border border-gray-300 rounded-lg bg-gray-100"
        />
        <input
          type="text"
          placeholder="COUNTRY"
          value={country}
          readOnly
          className="p-3 border border-gray-300 rounded-lg bg-gray-100"
        />
      </div>
      {/* PAYMENT */}
      <div>
        <h6 className="text-lg font-semibold text-gray-700">PAYMENT</h6>
        <CardElement className="p-3 border border-gray-300 rounded-lg" />
      </div>

      {/* SUBMIT BUTTON */}
      <button
        type="submit"
        disabled={!stripe || !elements}
        className="w-full bg-[#F4CF38] text-black font-semibold py-3 rounded-lg  transition duration-300 disabled:bg-gray-400"
      >
        Pay Now
      </button>
    </form>
  );
};
const Main = () => {
    const [cartProducts, setCartProducts] = useState([]);
    const [cartProductsTotal, setCartProductsTotal] = useState({ total: 0, shipping: 0 });
    const [isLoading, setIsLoading] = useState(true);
    const userId = sessionStorage.getItem("userId") || sessionStorage.getItem("randomUserId");
    const url = new URL(window.location.href); 
    const params = new URLSearchParams(url.search); 
    const productid = params.get('productid'); 
    const quantity = Number(params.get('quantity')); 
    const [products, setProducts] = useState({});

    const getProductData = async () => {
        try {
          const res = await ProductServices.getProductById(productid);
          if (res.status) {
            setProducts(res.data);
            const totalPrice = res.data.price * quantity;
            setCartProductsTotal({ total: totalPrice, shipping: 0 }); // Assuming no shipping cost for now
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching product data:", error);
        }
    };

    useEffect(() => {
        getProductData();
    }, [userId]);
    if (isLoading) {
      return (
        <div className="flex justify-center items-center py-16 bg-[#fff]">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#F4CF38]"></div>
    </div>
      );
    }
    return (
        <>
            <div className="container mx-auto px-4 py-8 text-left">
      <h2 className="text-3xl font-bold text-center mb-6">CHECKOUT</h2>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left Section: Checkout Form */}
        {/* <div className="bg-white shadow-lg rounded-lg p-6"> */}
          <Elements stripe={stripePromise}>
            <CheckoutForm cartProductsTotal={cartProductsTotal.total} userId={userId} />
          </Elements>
        {/* </div> */}

        {/* Right Section: Product Summary */}
        <div>
          <div className="bg-white shadow-lg rounded-lg p-6 mb-4">
            <div key={products.id} className="flex items-center gap-4">
              <img className="w-24 h-24 object-cover rounded-lg" src={`${BASE_URL}${products.image}`} alt={products.name} />
              <div>
                <span className="text-lg font-semibold">{products.name}</span>
                <span className="block text-gray-600 mt-1">${products.price}</span>
              </div>
            </div>
          </div>

          {/* Subtotal Section */}
          <div className="bg-white shadow-lg rounded-lg p-6 mb-4">
            <div className="flex justify-between text-lg font-semibold">
              <span>Subtotal ({quantity})</span>
              <span>${cartProductsTotal.total}</span>
            </div>
            <div className="flex justify-between text-gray-600 mt-2">
              <span>Shipping</span>
              <span>${cartProductsTotal.shipping}</span>
            </div>
            <div className="flex justify-between font-bold text-lg mt-2">
              <span>Total</span>
              <span>${cartProductsTotal.total}</span>
            </div>
          </div>

          {/* Discount Section */}
          {/* <div className="flex items-center gap-2">
            <Form.Control
              className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              type="text"
              placeholder="Apply discount"
            />
            <button className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-300">
              Apply
            </button>
          </div> */}
        </div>
      </div>
    </div>
        </>
    );
};

export default Main;
